/* Row detail drawer. Ported verbatim from artifact.html.
   The closing note is load-bearing: observed signals are literal patterns in the query
   text, and everything under model inference is heuristic — never Google attribution. */

import { oppMeta } from "@oqc/classifier";
import { $, esc, fmt } from "../util.js";
import { bpill, spill, OPP_TONE } from "../colors.js";

export function openDrawer(detail) {
  const d = detail.row;
  const meta = d.oscore != null ? oppMeta(d.oscore) : null;
  const tone = meta ? OPP_TONE[meta.tone] : null;
  const drow = (l, v) => (v ? '<div class="drow"><span class="l">' + l + "</span><span>" + v + "</span></div>" : "");
  const stageDef = detail.stageDefinition;

  $("drawer-root").innerHTML =
    '<div class="drawer-scrim" id="dscrim"></div><div class="drawer">' +
    '<div style="display:flex;justify-content:space-between;margin-bottom:12px"><span class="lbl">Query</span><button class="xbtn" id="dclose">✕</button></div>' +
    '<div id="dq" style="font-size:15px;font-weight:700;line-height:1.4;margin-bottom:14px;font-family:var(--mono)">"' + esc(d.q) + '"</div>' +
    '<div style="display:flex;gap:7px;flex-wrap:wrap;margin-bottom:16px">' + bpill(d.bucket) +
    (d.stage ? spill(d.stage) : "") +
    '<span class="pill" style="color:var(--magenta);background:var(--magenta-soft)">conv score ' + d.cscore + "</span>" +
    '<span class="pill" style="color:var(--sub);background:#F1F1F4">' + d.conf + "% · " + (d.by || "rule") + "</span>" +
    (d.aiPage ? '<span class="pill" style="color:#0EA5E9;background:rgba(14,165,233,.09)">on AI page</span>' : "") +
    (tone ? '<span class="pill" style="color:' + tone.c + ";background:" + tone.bg + '">opp ' + d.oscore + "</span>" : "") + "</div>" +
    '<div style="display:grid;grid-template-columns:repeat(4,1fr);gap:8px;margin-bottom:16px">' +
    [["Clicks", fmt(d.clicks)], ["Impr", fmt(d.imp)], ["CTR", d.ctr.toFixed(1) + "%"], ["Pos", d.pos.toFixed(1)]].map(x =>
      '<div style="border:1px solid var(--line);border-radius:10px;padding:8px 10px"><div style="font-size:9.5px;color:var(--muted);font-weight:700;text-transform:uppercase">' + x[0] +
      '</div><div style="font-family:var(--mono);font-size:14px;font-weight:800;margin-top:2px">' + x[1] + "</div></div>").join("") + "</div>" +
    '<div style="font-size:13.5px;font-weight:800;margin-bottom:4px">Model inference</div>' +
    (d.pattern !== d.bucket ? drow("Detected pattern", '<span style="font-family:var(--mono);font-size:11.5px">' + d.pattern + "</span>") : "") +
    drow("Conversation stage", d.stage && "<b>" + esc(d.stage) + "</b>") +
    (stageDef ? '<div style="font-size:11.5px;color:var(--muted);padding:5px 0 7px;border-bottom:1px solid var(--line-soft);line-height:1.5">' + esc(stageDef.doing) + "</div>" : "") +
    (d.tier ? drow("Signal tier", '<b style="color:var(--magenta)">' + d.tier + "</b>") : "") +
    drow("Question type", d.qt && d.qt !== "none" && "<b>" + d.qt + "</b>") +
    drow("Intent", d.intent && "<b>" + d.intent + "</b>") +
    drow("User need", d.need && "<b>" + d.need + "</b>") +
    drow("Journey stage", d.journey && "<b>" + d.journey + "</b>") +
    drow("Topic", d.topic && '<span class="pill" style="color:var(--violet);background:var(--violet-soft)">' + esc(d.topic) + "</span>" +
      (d.sub ? ' <span class="pill" style="color:var(--sub);background:#F1F1F4">' + esc(d.sub) + "</span>" : "")) +
    (d.page
      ? drow("Landing page", '<span class="dpage" style="font-family:var(--mono);font-size:10.5px">' + esc(d.page) + "</span>")
      : d.aiMatch
        ? drow("AI page match (inferred)", '<span class="dpage" style="font-family:var(--mono);font-size:10.5px">' + esc(d.aiMatch) + "</span>")
        : "") +
    '<div style="font-size:13.5px;font-weight:800;margin:16px 0 4px">Observed signals</div>' +
    (d.hits.length ? d.hits.map(h => '<div class="sig">' + esc(h) + "</div>").join("")
      : '<div style="font-size:12px;color:var(--muted)">No conversational patterns present in the query text.</div>') +
    '<div style="margin-top:14px;background:var(--bg);border:1px solid var(--line);border-radius:10px;padding:9px 12px;font-size:11px;color:var(--muted);line-height:1.55">ⓘ Observed signals are literal patterns in the query text; everything under model inference is heuristic — not Google source attribution.</div>' +
    "</div>";

  $("dclose").addEventListener("click", closeDrawer);
  $("dscrim").addEventListener("click", closeDrawer);
}

export function closeDrawer() {
  $("drawer-root").innerHTML = "";
}

document.addEventListener("keydown", e => { if (e.key === "Escape") closeDrawer(); });
